import accessDenied from './en/access-denied.ts'
import dashboard from './en/dashboard.ts'
import general from './en/general.ts'

export const additionalMessages = {
  en: {
    general,
    dashboard,
    accessDenied,
  },
}
